import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { LinkData } from "../../templates/template-link/template-link.component";
import { TemplateNotificationComponent } from "../../templates/template-notification/template-notification.component";

@Component({
  selector: "app-prefix-toe",
  imports: [TemplateNotificationComponent],
  templateUrl: "./prefix-toe.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-toe.component.less",
})
export class PrefixToeComponent extends PrefixComponent<string> implements OnInit {
  @Input()
  public severity: number;

  @Input()
  public links: LinkData[];

  @Input()
  public sslinks: LinkData[];

  public constructor() {
    super();
    this.post = false;
    this.severity = 1;
    this.characters = ALLOWED_CHARACTERS["toe"];
    this.links = [];
    this.sslinks = [];
  }

  public ngOnInit(): void {
    this.hide = !this.value;
    super.ngOnInit();
  }
}
